<!--
  - Copyright Huesik (c) 2019.
  -->

<template>
  <modal-layout modal-name="suggestion-kosiwon-info-modal" :width="getSize()">
    <div slot="contents" class="contents">
      <img src="../../assets/images/ex-logo@2x.png" alt="로고 이미지" />
      <p>고시락이 인증한 추천 고시원입니다.</p>
      <span>
        추천 고시원 등록 문의: <a href="tel://029119051">02-911-9051</a>
      </span>
    </div>
    <div slot="footer" class="edit-footer">
      <button @click="closeModal">확인</button>
    </div>
  </modal-layout>
</template>

<script>
  import ModalLayout from '../Layout/ModalLayout'
  import Utils from '../../utils/Utils'
  export default {
    name: 'SuggestKosiwonInfoModal',
    components: {
      ModalLayout
    },
    methods: {
      closeModal () {
        this.$modal.hide('suggestion-kosiwon-info-modal')
      },
      getSize () {
        return Utils.isSmallScreen() ? '100%' : 500
      }
    }
  }
</script>

<style scoped lang="less">
  @import "../../assets/css/palette";
  .contents {
    text-align: center;
    p {
      font-size: 2rem;
      padding: 2rem 0;
      font-weight: bold;
    }
    span {
      a {
        font-weight: bold;
        color: @windows-blue;
      }
    }
  }
  .edit-footer {
    /*padding: 1.5rem 4rem 0;*/
    button {
      height: 50px;
      background-color: @windows-blue;
      width: 100%;
      color: white;
      font-weight: bold;
    }
  }
</style>
